module.exports = __webpack_public_path__ + "img/logo-rural.b07a70a2.png";